import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import i18n from "i18next";
import PunchView from "./PunchView";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PUNCH, ROOT } from "../../navigation/CONSTANTS";

import { DialogTitle, Dialog } from "@material-ui/core";

import MealDataModal from "./components/MealDataModal";

import {
  LOCATIONS,
  JOB_FAMILIES,
  ACTIVITY_GROUP,
  CLOCK_IN,
  STATUS,
  CLOCK_OUT,
  TRANSFER,
  MISSED_CLOCK_IN,
  MISSED_CLOCK_OUT,
  DEFAULT_JOB_FAMILY,
  DEFAULT_ACTIVITY_GROUP,
  timeConfig,
  dateConfig,
  SET_EMPTY,
  PROJECT,
  EMPTY,
  MEAL,
} from "./config";
import { CUSTOMER_SITE, LAST, TESTCOUNTRY } from "config/CONSTANTS";
import {
  getJobProjectInfo,
  getActivityGroupByLanguage,
  getJobFamiliesByLanguage,
  getBuildings,
  getUniqueID,
  getCustomerSite,
  getProjectsByActivityGroup,
  getActivityDetails,
  getHoursFormat,
} from "../../utils/punch";

import { getPunch } from "../../utils/punch";

import {
  ZERO,
  NEGATIVE,
  EQUAL,
  OVERLAPPING,
  POSITIVE,
  DAY24HRS,
  ADD,
  UPDATE,
  CLOCKIN,
  CLOCKOUT,
  MISSEDCLOCKIN,
  MISSEDCLOCKOUT,
  categoryPunch,
} from "../Punch/constants";

//backend
import {
  addPunch,
  updatePunch,
  getNewWorkerPunchRecords,
  setLastPunch,
  getPreviousPunches,
  getWeekHoursDetails,
  getWeekNumber,
} from "../../services";
import {
  getActivityGroups,
  getJobFamilies,
  getLocations,
  getPunchLoading,
} from "../../redux/actions/appActions";
import { DEVICE_DETAILS } from "config";
import {
  getDistrictsByCountry,
  setDefaultValue,
  toggleDisableException,
  validateEntries,
} from "utils";
import { EventEmitter } from "utils/EventEmitter";

/**
 * Verify user.
 * On page load, check if the user is verified.
 * If user is not verified, redirect back to home page.
 * Else continue to record new punch.
 */

export const PunchContainer = (props) => {
  const { user, lastPunch, lastActGrp } = useSelector((state) => state.user);
  const [lastPunchLoadFlag, setLastPunchLoadFlag] = useState(false);
  const appConfig = useSelector((state) => state.appConfig);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let isVisibleMissedClockIn = false;
  let isVisibleMissedClockOut = false;
  let isVisibleTransfer = false;
  let isVisibleClockIn = false;
  let lastPunchStatus = SET_EMPTY;
  let lastPunchTime = SET_EMPTY;
  let lastPunchClock = SET_EMPTY;
  let defaultDistrict = [
    {
      value: -1,
      label: t("general.select1"),
      buildings: [{ value: -1, label: t("general.select2") }],
    },
  ];
  const defaultJobFamily = [{ label: t("general.select3"), value: -1 }];
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
  const defaultActivity = [
    { label: t("other.lblSelectActivityName"), value: " " },
  ];
  const defaultProject = [
    { label: t("other.lblSelectProjectName"), value: " " },
  ];
  const defaultLeave = [{ label: "Select Leave Type", value: " " }];
  const [disableTransfer, setDisableTransfer] = useState(true);
  const [disableClockOut, setDisableClockOut] = useState(false);
  const [disableClockIn, setDisableClockIn] = useState(false);
  const [disableException, setDisableException] = useState(false);
  const [disableExceptionLoader, setDisableExceptionLoader] = useState(false);
  

  const [missedClockOutMeal, setmissedClockOutMeal] = useState(false);

  const [disableForTime, setDisableForTime] = useState(false);
  const [disableForDate, setDisableForDate] = useState(false);
  const [helperTextForFutureTime, setHelperTextForFutureTime] =
    useState(SET_EMPTY);
  let isPersist = false;
  //hardcoded district removed
  let districtOptions;
  const [district, setDistrict] = useState(defaultDistrict[0].value);

  const [building, setBuilding] = useState(
    defaultDistrict[0].buildings[0].value
  );
  const [buildingOptions, setBuildingOptions] = useState(
    defaultDistrict[0].buildings
  );

  let jobFamiliesOptions = getJobFamiliesByLanguage(
    i18n.language,
    JOB_FAMILIES
  );
  let specialProjects =jobFamiliesOptions;
  const [jobFamily, setJobFamily] = useState(defaultJobFamily[0].value);

  let activityGroupOptions = getActivityGroupByLanguage(
    i18n.language,
    ACTIVITY_GROUP
  );
  let projectOptions = [];
  const [activityGroup, setActivityGroup] = useState(defaultAG[0].value);
  const [project, setProjectValue] = useState(defaultActivity[0].value);
  const [exceptionDate, setExceptionDate] = useState(new Date());
  const [exceptionTime, setExceptionTime] = useState(new Date());
  const [modalExceptionTimeStamp, setModalExceptionTimeStamp] = useState(false);

  const [confirmationMsg, setConfirmationMsg] = useState(false);
  const [confirmationMsgText, setConfirmationMsgText] = useState(SET_EMPTY);

  const [confirmationTitleText, setConfirmationTitleText] = useState(SET_EMPTY);
  const [allowNavigation, setAllowNavigation] = useState(true);

  const [specialProjectDialog, setSpecialProjectDialog] = useState(false);
  const [specialProject, setSpecialProject] = useState(SET_EMPTY);
  const [isDisabledSpecialProjectOK, setIsDisabledSpecialProjectOK] =
    useState(true);
  const [jobProjectInfoLabel, setJobProjectInfoLabel] = useState(SET_EMPTY);
  const [projectInfoLabel, setprojectInfoLabel] = useState(SET_EMPTY);
  const [otherProject, setOtherProject] = useState(SET_EMPTY);
  const [jobProjectInfoVisible, setJobProjectInfoVisible] = useState(false);
  const [projectInfoVisible, setprojectInfoVisible] = useState(false);
  const [otherProjectInfoVisible, setOtherProjectInfoVisible] = useState(false);
  const [errProjectInfoEntry, setErrProjectInfoEntry] = useState(false);

  const [customerSite, setCustomerSite] = useState(SET_EMPTY);
  const [errCustomerSite, setErrCustomerSite] = useState(false);
  const [otherProjectErr, setOtherProjectErr] = useState(SET_EMPTY);
  const [customerSiteVisible, setCustomerSiteVisible] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [punchHistoryDetails, setPunchHistoryDetails] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [mealStartProgress, setMealStartProgress] = useState(false);
  const [mealReminder, setMealReminder] = useState(false);

  const [weekHoursDiagolueOpen, setWeekHoursDiagolueOpen] = useState(false);
  const [weekHoursDetails, setWeekHoursDetails] = useState([]);
  const [weekHoursDataLoaded, setWeekHoursDataLoaded] = useState(false);

  React.useEffect(() => {
    EventEmitter.subscribe("openConfirmMessage", () => {
      setConfirmationTitleText("Confirmation");
      setConfirmationMsgText("Captured Successfully");
      setConfirmationMsg(true);
      setAllowNavigation(true);
    });

    EventEmitter.subscribe("openErrorMessage", (err) => {
      setConfirmationTitleText("Error");
      setConfirmationMsgText(err);
      setConfirmationMsg(true);
      setAllowNavigation(false);
    });
  }, []);

  // get all drop-down values from back end
  try {
    if (
      appConfig !== null &&
      appConfig.activityGroups !== null &&
      appConfig.jobFamilies !== null &&
      appConfig.projects !== null &&
      (appConfig.locations !== null || appConfig.locations.length > 0)
    ) {
      // console.log('setting drop downs')
      // isLocLoading = appConfig.locationLoader;
      // if (appConfig.deviceCountry) {
      //   const deviceCountry = appConfig.deviceCountry.toLowerCase();
      //   if (appConfig.locations[deviceCountry])
      //     defaultDistrict = defaultDistrict.concat(
      //       appConfig.locations[deviceCountry]
      //     );
      // }

      if (
        user &&
        user.country === TESTCOUNTRY &&
        appConfig.locations.default &&
        appConfig.locations.default.length > 0
      ) {
        // isLocLoading = false;
        // districtOptions = districtOptions[0].concat(appConfig.locations.default);
        districtOptions = [defaultDistrict[0], ...appConfig.locations.default];
      } else {
        districtOptions = defaultDistrict;
        if (user && user.countryCode && appConfig.locations) {
          const userCountry = user.countryCode.toLowerCase();

          if (appConfig.locations[userCountry]) {
            // isLocLoading = false;
            // if (userCountry !== appConfig.deviceCountry.toLowerCase()) {
            districtOptions = defaultDistrict.concat(
              appConfig.locations[userCountry]
            );
            // }
          }
        }
        if (user && user.alternateCountryCode && appConfig.locations) {
          const userAlternateCountry = user.alternateCountryCode.toLowerCase();

          if (appConfig.locations[userAlternateCountry]) {
            // isLocLoading = false;
            // if (
            //   userAlternateCountry !== appConfig.deviceCountry.toLowerCase()
            // ) {
            districtOptions = [
              ...districtOptions,
              ...appConfig.locations[userAlternateCountry],
            ];
            // }
          }
        } else if (user && !user.countryCode && defaultDistrict.length > 1) {
          // isLocLoading = false;
        }
      }

      // originalBuildingValue = districtOptions[0].buildings[0].value;

      jobFamiliesOptions = getJobFamiliesByLanguage(
        i18n.language,
        appConfig.jobFamilies
      );
      jobFamiliesOptions = defaultJobFamily.concat(jobFamiliesOptions);
      specialProjects = jobFamiliesOptions.filter(
        (item) => item.projectInfoEntryType === 'id'
      );
      activityGroupOptions = getActivityGroupByLanguage(
        i18n.language,
        appConfig.activityGroups
      );
      activityGroupOptions = defaultAG.concat(activityGroupOptions);
      let filteredActivityGroups = jobFamiliesOptions.filter((item)=>{
        return item.actGrpsRestrctd===true && 
        item.actGrps.length>0 && item.value ===jobFamily;
      });
      if(filteredActivityGroups && filteredActivityGroups.length>0){
        const restrictedActGrps = filteredActivityGroups[0].actGrps;
        activityGroupOptions = activityGroupOptions.filter(
          (item) =>  restrictedActGrps.includes(item.value)
        );
        activityGroupOptions = defaultAG.concat(activityGroupOptions);
      }
      projectOptions = getProjectsByActivityGroup(
        appConfig.projects,
        activityGroup,
        defaultActivity,
        defaultProject,
        defaultLeave,
        jobFamily,
        district
      );

      if(activityGroup && activityGroup ===PROJECT && projectOptions.length>1){
        projectOptions.push({ label: t("other.lblOther") , value: 'Other' });
      }

    }
  } catch (error) {
    console.warn("error in appconfig setting default", appConfig);

    districtOptions = defaultDistrict; //for showing select district option when nothing is there
    //removed below two lines for removal of hardcoded data when location is not present
    // districtOptions = LOCATIONS; // setting defaults
    // districtOptions = defaultDistrict.concat(districtOptions);
    jobFamiliesOptions = getJobFamiliesByLanguage(i18n.language, JOB_FAMILIES); // setting defaults
    activityGroupOptions = getActivityGroupByLanguage(
      i18n.language,
      ACTIVITY_GROUP
    ); // setting defaults
  }

  const back = () => {
    // history.push(ROOT);
    history.goBack();
  };

  const handleChangeSpecialProject = (event) => {
    const value = event.target.value;
    setJobProjectInfoVisible(true);
    setJobProjectInfoLabel(value);

    // if (value.length === 0) {
    //   setIsDisabledSpecialProjectOK(true);
    //   setErrProjectInfoEntry(true);
    // } else {
    //   setIsDisabledSpecialProjectOK(false);
    //   setErrProjectInfoEntry(false);
    // }
  };

  const handleChangeProjectDetails =(event) =>{
    const value = event.target.value;
    setprojectInfoVisible(true);
    setprojectInfoLabel(value);
  }
  const handleOtherProjectDetails =(event)=>{
    const value = event.target.value;
    if(value && value != defaultProject[0].value){
      const i = projectOptions.find((item) => value.trim().toLowerCase() === item.value.toLowerCase());
      if(i){
        setOtherProjectErr('Entered Text matched with existing project details');
      }else {
        setOtherProjectErr(SET_EMPTY)
      }
      
    }
    setOtherProjectInfoVisible(true);
    setOtherProject(value);
  }
  const okSpecialProjectDialog = () => {
    setSpecialProjectDialog(false);
    if (specialProject.length === 0) {
      setJobFamily(DEFAULT_JOB_FAMILY);
    }
  };

  const cancelSpecialProjectDialog = () => {
    setSpecialProjectDialog(false);
    setSpecialProject(SET_EMPTY);
    if (activityGroup === PROJECT) {
      setActivityGroup(DEFAULT_ACTIVITY_GROUP);
    }
  };

  const handleExceptionDateChange = (date) => {
    let selectedDate = moment(date).format(dateConfig.format6);
    let maxDate = moment(new Date()).format(dateConfig.format6);
    if (selectedDate < lastPunchClock || selectedDate > maxDate) {
      setDisableForDate(true);
    } else {
      setDisableForDate(false);
    }
    setExceptionDate(date);
  };

  const handleExceptionTimeChange = (date) => {
    //console.log("handleExceptionTimeChange :", date,exceptionDate.getDate());
    setExceptionTime(date);
  };

  if (lastPunch && lastPunch.activityName) {
    if (lastPunch.status !== "deleted") {
      lastPunchTime =
        moment(lastPunch.activityTS).format(dateConfig.format2) +
        " " +
        moment(lastPunch.activityTS).format(timeConfig.format3);

      lastPunchClock = moment(lastPunch.activityTS).format(dateConfig.format6);
      if (
        lastPunch.activityName === CLOCK_IN ||
        lastPunch.activityName === TRANSFER
      ) {
        let ts = lastPunch.inLocalTS;
        if (ts === "" || ts === undefined) {
          ts = lastPunch.activityTS;
        }

        lastPunchTime =
          moment(ts).format(dateConfig.format2) +
          " " +
          moment(ts).format(timeConfig.format3);
        lastPunchClock = moment(ts).format(dateConfig.format6);
        lastPunchStatus = t("pgPunch.lblClockedIn");
        lastPunchTime = t("pgPunch.lblIn") + " " + lastPunchTime;
        isVisibleMissedClockOut = true;
        isVisibleTransfer = true;
        isVisibleClockIn = false;
      } else if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
        let ts = lastPunch.outLocalTS;
        if (ts === "" || ts === undefined) {
          ts = lastPunch.activityTS;
        }
        lastPunchTime =
          moment(ts).format(dateConfig.format2) +
          " " +
          moment(ts).format(timeConfig.format3);
        lastPunchClock = moment(ts).format(dateConfig.format6);
        lastPunchStatus = t("pgPunch.lblClockedOut");
        lastPunchTime = t("pgPunch.lblOut") + " " + lastPunchTime;
        isVisibleMissedClockIn = true;
        isVisibleClockIn = true;
      } else {
        lastPunchStatus = t("pgPunch.lblClockedOut");
        isVisibleTransfer = false;
        isVisibleClockIn = true;
        isVisibleMissedClockOut = false;
      }
    } else {
      // setLastPunch(lastPunch.workerId)
      // .then((doc) => {
      //   console.log("LastPunch change Completed...", doc);
      // })
      // .catch((err) => {
      //   console.log("error changing lastPunch status!", err);
      // })
      lastPunchTime =
        moment(lastPunch.activityTS).format(dateConfig.format2) +
        " " +
        moment(lastPunch.activityTS).format(timeConfig.format3);

      lastPunchClock = moment(lastPunch.activityTS).format(dateConfig.format6);
      if (
        lastPunch.activityName === CLOCK_IN ||
        lastPunch.activityName === TRANSFER
      ) {
        let ts = lastPunch.inLocalTS;
        if (ts === "" || ts === undefined) {
          ts = lastPunch.activityTS;
        }

        lastPunchTime =
          moment(ts).format(dateConfig.format2) +
          " " +
          moment(ts).format(timeConfig.format3);
        lastPunchClock = moment(ts).format(dateConfig.format6);
        lastPunchStatus = t("pgPunch.lblClockedIn");
        lastPunchTime = t("pgPunch.lblIn") + " " + lastPunchTime;
        isVisibleMissedClockOut = true;
        isVisibleTransfer = true;
        isVisibleClockIn = false;
      } else if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
        let ts = lastPunch.outLocalTS;
        if (ts === "" || ts === undefined) {
          ts = lastPunch.activityTS;
        }
        lastPunchTime =
          moment(ts).format(dateConfig.format2) +
          " " +
          moment(ts).format(timeConfig.format3);
        lastPunchClock = moment(ts).format(dateConfig.format6);
        lastPunchStatus = t("pgPunch.lblClockedOut");
        lastPunchTime = t("pgPunch.lblOut") + " " + lastPunchTime;
        isVisibleMissedClockIn = true;
        isVisibleClockIn = true;
      } else {
        lastPunchStatus = t("pgPunch.lblClockedOut");
        isVisibleTransfer = false;
        isVisibleClockIn = true;
        isVisibleMissedClockOut = false;
      }
    }
  } else {
    isVisibleClockIn = true;
    isVisibleMissedClockIn = true;
    // isDisabledClockOut = true
    // setDisableClockOut(true)
  }

  const districtChange = (event) => {
    const selectedDistrict = event.target.value;
    setDistrict(selectedDistrict);
    setBuildingOptions(getBuildings(selectedDistrict, districtOptions));
    setProjectValue(defaultActivity[0].value);
    if (lastPunch && lastPunch.buildingId) {
      //setBuilding(buildingOptions[0].value);

      setDefaultValue(
        buildingOptions,
        lastPunch.buildingId,
        buildingOptions[0].value,
        setBuilding
      );
    } else {
      setBuilding(buildingOptions[0].value);
    }

    if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      setDisableClockOut(true);
    }

    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave,
      jobFamily,
      event.target.value
    );
  };
  const buildingChange = (event) => {
    const selectedBuilding = event.target.value;
    setBuilding(selectedBuilding);

    if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      setDisableClockOut(true);
    }
    if (selectedBuilding === CUSTOMER_SITE) {
      setCustomerSiteVisible(true);
    } else {
      setCustomerSite(SET_EMPTY);
      setCustomerSiteVisible(false);
    }
  };

  const jobFamilyChange = (event) => {
    const selectedJobFamily = event.target.value;
    setJobFamily(selectedJobFamily);
    let jobRoleRecord = jobFamiliesOptions.filter(
      (item) => item.value === selectedJobFamily
    );
    if(jobRoleRecord && jobRoleRecord[0] && jobRoleRecord[0].projectInfoEntryType ==='id'){
      console.log('jobFamilyChange if:');
      setprojectInfoVisible(true);
    }else {
      console.log('jobFamilyChange else:');
      setprojectInfoVisible(false);
    }
    if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      setDisableClockOut(true);
    }
    
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave,
      selectedJobFamily,
      district
    );
  };

  const activityGroupChange = (event) => {
    const selectedActivityGroup = event.target.value;

    let j = activityGroupOptions.filter(
      (item) => item.value === selectedActivityGroup
    );
    const activityGroup = j[0].value;

    setActivityGroup(selectedActivityGroup);
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave,
      jobFamily,
      district
    );

    if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      setDisableClockOut(true);
    }
  };
  const projectGroupHandler = (event) => {
    const projectGroup = event.target.value;
    let j = projectOptions.filter((item) => item.value === projectGroup);
    setJobProjectInfoVisible(false);
    setOtherProjectInfoVisible(false);
    const i = projectOptions.find((item) => projectGroup === item.value);
    if(activityGroup ===PROJECT && !i && projectGroup){
      setProjectValue('Other');
      setOtherProjectInfoVisible(true);
      setOtherProject(lastPunch.jobProjectInfo);
    }else {
      setDefaultValue(
        projectOptions,
        projectGroup,
        defaultActivity[0].value,
        setProjectValue
      );
    }
    
  };

  const clockIn = () => {
    setDisableClockIn(true);
    //    const jobProjectInfo = getJobProjectInfo(specialProject);
    const activityName = CLOCK_IN;
    const exceptionName = SET_EMPTY;
    const version = getUniqueID();
    const timeStamp = new Date();
    const actionTS = timeStamp.toISOString();
    const inTS = timeStamp.toISOString();
    const inLocalTS = moment(timeStamp).format(dateConfig.format4);
    const outTS = SET_EMPTY;
    const outLocalTS = SET_EMPTY;
    const customerSiteVal = getCustomerSite(customerSite);
    const punch = getPunch(
      activityGroup,
      activityName,
      building,
      district,
      customerSiteVal,
      exceptionName,
      false,
      jobFamily,
      project,
      STATUS,
      version,
      user.workerId,
      actionTS,
      inTS,
      inLocalTS,
      outTS,
      outLocalTS,
      user.workerId,
      DEVICE_DETAILS,
      categoryPunch
    );

    if (jobProjectInfoVisible) {
      punch.jobProjectInfo = jobProjectInfoLabel.trim();
    } else if (project == " ") {
      punch.jobProjectInfo = SET_EMPTY;
    }

    if (otherProjectInfoVisible) {
      punch.jobProjectInfo = otherProject.trim();
    }

    if (customerSiteVisible && customerSite == SET_EMPTY) {
      setErrCustomerSite(true);
      setDisableClockIn(false);
      return;
    }

    if(projectInfoVisible){
      punch.projectDetails = projectInfoLabel.trim();
    }else {
      punch.projectDetails = SET_EMPTY;
    }

    console.log("CLOCK IN >", punch);

    // console.log("Clock In Punch" + JSON.stringify(punch));
    // Validation scenarios
    const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
    const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
    let isPass = "";
    let action = "";
    let punchstatus = "";
    getNewWorkerPunchRecords(
      punch.workerId,
      moment(startdate).subtract(1, "days").format(dateConfig.format4),
      moment(startdate).add(1, "days").format(dateConfig.format4)
    )
      .then((querySnapshot) => {
        console.log("querySnapshot....." + querySnapshot);
        punchstatus = CLOCKIN;
        if (querySnapshot != undefined && querySnapshot.length > 0) {
          querySnapshot.forEach((doc) => {
            doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
            doc.outLocalTS = moment(doc.outLocalTS).format(dateConfig.format7);
            if (
              recentPunchIn > doc.inLocalTS &&
              recentPunchIn < doc.outLocalTS
            ) {
              isPass = OVERLAPPING;
            } else if (recentPunchIn == doc.inLocalTS) {
              isPass = EQUAL;
            } else {
              if (isPass != OVERLAPPING && isPass != EQUAL) {
                isPass = POSITIVE;
                action = ADD;
                punchstatus = CLOCKIN;
              }
            }
          });
        } else {
          isPass = POSITIVE;
          action = ADD;
          punchstatus = CLOCKIN;
        }
        getValidationScenarios(isPass, action, punch, {}, punchstatus);
      })
      .catch((error) => {
        console.log(error);
        setDisableClockIn(false);
      });
    // setDisableClockIn(false);
  };

  const mealReminderHandler = () => {
    console.log("you are in meal reminder");
    return (
      <Dialog aria-labelledby="simple-dialog-title" open={true}>
        <DialogTitle id="simple-dialog-title">Meal Reminder</DialogTitle>
      </Dialog>
    );
  };

  const clockOut = () => {
    setDisableClockOut(true);

    const activityName = CLOCK_OUT;
    const exceptionName = SET_EMPTY;
    const version = getUniqueID();
    const timeStamp = new Date();
    const outTS = timeStamp.toISOString();
    const actionTS = timeStamp.toISOString();
    const outLocalTS = moment(timeStamp).format(dateConfig.format4);
    const punch = getPunch(
      lastPunch.activityGroup,
      activityName,
      lastPunch.buildingId,
      lastPunch.districtId,
      lastPunch.customerSite ? lastPunch.customerSite : customerSite,
      lastPunch.exceptionName,
      lastPunch.isException,
      lastPunch.jobName,
      lastPunch.jobProjectInfo,
      lastPunch.status,
      lastPunch.version,
      lastPunch.workerId,
      actionTS,
      lastPunch.inTS,
      lastPunch.inLocalTS,
      outTS,
      outLocalTS,
      user.workerId,
      DEVICE_DETAILS,
      categoryPunch
    );

    console.log("Clockout Punch", punch);
    if(projectInfoVisible){
      punch.projectDetails = projectInfoLabel.trim();
    }else {
      punch.projectDetails = SET_EMPTY;
    }
    console.log("Clock Out Punch" + JSON.stringify(punch));
    const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
    const endDate = moment(punch.outLocalTS).format(dateConfig.format6);
    const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
    const recentPunchOut = moment(punch.outLocalTS).format(dateConfig.format7);
    let isPass = "";
    let action = "";
    let punchstatus = "";
    const dayDiff = parseInt(
      moment
        .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
        .asMinutes()
    );
    console.log("DayDIff......." + dayDiff);
    getNewWorkerPunchRecords(
      punch.workerId,
      moment(startdate).subtract(1, "days").format(dateConfig.format4),
      moment(endDate).add(1, "days").format(dateConfig.format4)
    )
      .then((querySnapshot) => {
        console.log("querySnapshot....." + querySnapshot);
        punchstatus = CLOCKOUT;
        if (querySnapshot != undefined && querySnapshot.length > 0) {
          querySnapshot.forEach((doc) => {
            doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
            doc.outLocalTS = moment(doc.outLocalTS).format(dateConfig.format7);
            lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
              dateConfig.format7
            );
            lastPunch.outLocalTS = moment(lastPunch.outLocalTS).format(
              dateConfig.format7
            );
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            }
            // else if (dayDiff >= 1440) {
            //   isPass = DAY24HRS;
            // }
            else if (
              //   recentPunchIn == doc.inLocalTS &&
              //   recentPunchOut == doc.outLocalTS
              // ) {
              //   isPass = EQUAL;
              // } else if (
              lastPunch.inLocalTS != doc.inLocalTS &&
              lastPunch.outLocalTS != doc.outLocalTS
            ) {
              if (
                (doc.inLocalTS > recentPunchIn &&
                  doc.inLocalTS < recentPunchOut) ||
                (doc.outLocalTS > recentPunchIn &&
                  doc.outLocalTS < recentPunchOut) ||
                (recentPunchIn > doc.inLocalTS &&
                  recentPunchIn < doc.outLocalTS) ||
                (recentPunchOut > doc.inLocalTS &&
                  recentPunchOut < doc.outLocalTS)
              ) {
                isPass = OVERLAPPING;
              }
            } else {
              if (
                isPass != NEGATIVE &&
                isPass != ZERO &&
                // isPass != DAY24HRS &&
                isPass != OVERLAPPING &&
                isPass != EQUAL
              ) {
                isPass = POSITIVE;
                action = UPDATE;
              }
            }
          });
        } else {
          if (recentPunchOut == recentPunchIn) {
            isPass = ZERO;
          } else if (recentPunchOut < recentPunchIn) {
            isPass = NEGATIVE;
          }
          // else if (dayDiff >= 1440) {
          //   isPass = DAY24HRS;
          // }
          else {
            if (
              isPass != ZERO &&
              // isPass != DAY24HRS &&
              isPass != NEGATIVE
            ) {
              isPass = POSITIVE;
              action = UPDATE;
            }
          }
        }
        if (jobProjectInfoVisible) {
          punch.jobProjectInfo = jobProjectInfoLabel.trim();
        } else if (project == " ") {
          punch.jobProjectInfo = SET_EMPTY;
        }
        if (otherProjectInfoVisible) {
          punch.jobProjectInfo = otherProject.trim();
        }
        getValidationScenarios(isPass, action, punch, lastPunch, punchstatus);
      })
      .catch((error) => {
        console.log(error);
        setDisableClockOut(false);
      });
  };

  const mealStart = () => {
    console.log("You started the meal");
    setMealStartProgress(true);

    const version = getUniqueID();
    const timeStamp = new Date();
    const outTS = timeStamp.toISOString();
    const actionTS = timeStamp.toISOString();
    const outLocalTS = moment(timeStamp).format(dateConfig.format4);
    lastPunch.outTS = outTS;
    lastPunch.outLocalTS = outLocalTS;
    lastPunch.actionTS = actionTS;
    const activityName = TRANSFER;
    const activityGroup = MEAL;
    const exceptionName = "";

    const newPunch = getPunch(
      activityGroup,
      activityName,
      building,
      district,
      customerSite,
      exceptionName,
      false,
      jobFamily,
      project,
      STATUS,
      version,
      user.workerId,
      actionTS,
      outTS,
      outLocalTS,
      SET_EMPTY,
      SET_EMPTY,
      user.workerId,
      DEVICE_DETAILS,
      categoryPunch
    );
    const startdate = moment(lastPunch.inLocalTS).format(dateConfig.format6);
    const endDate = moment(outLocalTS).format(dateConfig.format6);
    const recentPunchIn = moment(lastPunch.inLocalTS).format(
      dateConfig.format7
    );
    const recentPunchOut = moment(outLocalTS).format(dateConfig.format7);
    let isPass = "";
    const dayDiff = parseInt(
      moment
        .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
        .asMinutes()
    );
    console.log("DayDIff......." + dayDiff);
    getNewWorkerPunchRecords(
      lastPunch.workerId,
      moment(startdate).subtract(1, "days").format(dateConfig.format4),
      moment(endDate).add(1, "days").format(dateConfig.format4)
    )
      .then((querySnapshot) => {
        console.log("querySnapshot....." + querySnapshot);
        if (querySnapshot != undefined && querySnapshot.length > 0) {
          querySnapshot.forEach((doc) => {
            doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
            doc.outLocalTS = moment(doc.outLocalTS).format(dateConfig.format7);
            lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
              dateConfig.format7
            );
            lastPunch.outLocalTS = moment(outLocalTS).format(
              dateConfig.format7
            );
            if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            }
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            }
            // else if (dayDiff >= 1440) {
            //   isPass = "24hrs";
            // }
            else if (
              //   recentPunchIn == doc.inLocalTS &&
              //   recentPunchIn == doc.outLocalTS
              // ) {
              //   isPass = EQUAL;
              // } else if (
              lastPunch.inLocalTS != doc.inLocalTS &&
              outLocalTS != doc.outLocalTS
            ) {
              if (
                (doc.inLocalTS > recentPunchIn &&
                  doc.inLocalTS < recentPunchOut) ||
                (doc.outLocalTS > recentPunchIn &&
                  doc.outLocalTS < recentPunchOut) ||
                (recentPunchIn > doc.inLocalTS &&
                  recentPunchIn < doc.outLocalTS) ||
                (recentPunchOut > doc.inLocalTS &&
                  recentPunchOut < doc.outLocalTS)
              ) {
                isPass = ZERO;
              }
            } else {
              if (
                isPass != NEGATIVE &&
                isPass != ZERO &&
                // isPass != "24hrs" &&
                isPass != EQUAL
              ) {
                isPass = POSITIVE;
              }
            }
          });
          if (isPass == ZERO) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgZero"));
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setMealStartProgress(false);
          } else if (isPass == NEGATIVE) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgNegative"));
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setMealStartProgress(false);
          } else if (isPass == EQUAL) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgEqual"));
            setAllowNavigation(false);
            setConfirmationTitleText(t("other.tlError"));
            setMealStartProgress(false);
          }
          // else if (isPass == "24hrs") {
          //   setConfirmationMsg(true);
          //   setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgDay24Hrs"));
          //   setConfirmationTitleText("Error");
          //   setAllowNavigation(false);
          //   setDisableTransfer(false);
          // }
          else {
            lastPunch.outLocalTS = outLocalTS;
            isPersist = getActivityDetails(activityGroupOptions, activityGroup);
            updatePunch(lastPunch.punchId, lastPunch, false, isPersist)
              .then((data) => {
                console.log("data :", data);
                const newPunch = getPunch(
                  activityGroup,
                  activityName,
                  building,
                  district,
                  customerSite,
                  exceptionName,
                  false,
                  jobFamily,
                  project,
                  STATUS,
                  version,
                  user.workerId,
                  actionTS,
                  outTS,
                  outLocalTS,
                  SET_EMPTY,
                  SET_EMPTY,
                  user.workerId,
                  DEVICE_DETAILS,
                  categoryPunch
                );
                if (jobProjectInfoVisible) {
                  newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
                } else if (project == " ") {
                  newPunch.jobProjectInfo = SET_EMPTY;
                }
                if (otherProjectInfoVisible) {
                  newPunch.jobProjectInfo = otherProject.trim();
                }
                if(projectInfoVisible){
                  newPunch.projectDetails = projectInfoLabel.trim();
                }else {
                  newPunch.projectDetails = SET_EMPTY;
                }
                console.log("Transfer Punch ", newPunch);
                isPersist = getActivityDetails(
                  activityGroupOptions,
                  activityGroup
                );
                addPunch(newPunch, false, isPersist)
                  .then((result) => {
                    console.log(result);
                    setConfirmationMsg(true);
                    setConfirmationMsgText(
                      t("pgReview.dialogueMsgs.msgSuccess")
                    );
                    setConfirmationTitleText(t("pgPunch.tlConfirmation"));
                    setAllowNavigation(true);
                    setMealStartProgress(false);
                  })
                  .catch((error) => {
                    console.log(error);
                    setMealStartProgress(false);
                  });
              })
              .catch((err) => {
                console.log(err);
                setMealStartProgress(false);
              });
          }
        } else {
          if (recentPunchOut <= recentPunchIn) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgNegative"));
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setMealStartProgress(false);
          }
          // else if (dayDiff >= 1440) {
          //   setConfirmationMsg(true);
          //   setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgDay24Hrs"));
          //   setConfirmationTitleText("Error");
          //   setAllowNavigation(false);
          //   setDisableTransfer(false);
          // }
          else {
            lastPunch.outLocalTS = outLocalTS;
            isPersist = getActivityDetails(activityGroupOptions, activityGroup);
            updatePunch(lastPunch.punchId, lastPunch, false, isPersist)
              .then((data) => {
                console.log("data", data);
                const newPunch = getPunch(
                  activityGroup,
                  activityName,
                  building,
                  district,
                  customerSite,
                  exceptionName,
                  false,
                  jobFamily,
                  project,
                  STATUS,
                  version,
                  user.workerId,
                  actionTS,
                  outTS,
                  outLocalTS,
                  SET_EMPTY,
                  SET_EMPTY,
                  user.workerId,
                  DEVICE_DETAILS,
                  categoryPunch
                );
                if (jobProjectInfoVisible) {
                  newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
                } else if (project == " ") {
                  newPunch.jobProjectInfo = SET_EMPTY;
                }
                if (otherProjectInfoVisible) {
                  newPunch.jobProjectInfo = otherProject.trim();
                }
                console.log("Meal Start Punch ", newPunch);
                isPersist = getActivityDetails(
                  activityGroupOptions,
                  activityGroup
                );
                addPunch(newPunch, false, isPersist)
                  .then((result) => {
                    console.log(result);
                    setConfirmationMsg(true);
                    setConfirmationMsgText(
                      t("pgReview.dialogueMsgs.msgSuccess")
                    );
                    setConfirmationTitleText(t("pgPunch.tlConfirmation"));
                    setAllowNavigation(true);
                    setMealStartProgress(false);
                  })
                  .catch((error) => {
                    console.log(error);
                    setMealStartProgress(false);
                  });
              })
              .catch((err) => {
                console.log(err);
                setMealStartProgress(false);
              });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setMealStartProgress(false);
      });
  };

  const transfer = () => {
    setDisableTransfer(true);
    //    const jobProjectInfo = getJobProjectInfo(specialProject);
    const activityName = TRANSFER;
    const exceptionName = SET_EMPTY;
    const version = getUniqueID();
    const timeStamp = new Date();
    const outTS = timeStamp.toISOString();
    const actionTS = timeStamp.toISOString();
    const outLocalTS = moment(timeStamp).format(dateConfig.format4);
    lastPunch.outTS = outTS;
    lastPunch.actionTS = actionTS;
    const customerSiteVal = getCustomerSite(customerSite);
    // if (jobProjectInfoVisible && jobProjectInfo == SET_EMPTY) {
    //   setErrProjectInfoEntry(true);
    //   setDisableTransfer(false);
    //   console.log("can not add record as there are errors on form");
    //   return; // come out and prevent adding punch
    // }

    if (customerSiteVisible && customerSite == SET_EMPTY) {
      setErrCustomerSite(true);
      setDisableTransfer(false);
      return;
    }

    const startdate = moment(lastPunch.inLocalTS).format(dateConfig.format6);
    const endDate = moment(outLocalTS).format(dateConfig.format6);
    const recentPunchIn = moment(lastPunch.inLocalTS).format(
      dateConfig.format7
    );
    const recentPunchOut = moment(outLocalTS).format(dateConfig.format7);
    let isPass = "";
    const dayDiff = parseInt(
      moment
        .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
        .asMinutes()
    );
    console.log("DayDIff......." + dayDiff);
    getNewWorkerPunchRecords(
      lastPunch.workerId,
      moment(startdate).subtract(1, "days").format(dateConfig.format4),
      moment(endDate).add(1, "days").format(dateConfig.format4)
    )
      .then((querySnapshot) => {
        console.log("querySnapshot....." + querySnapshot);
        if (querySnapshot != undefined && querySnapshot.length > 0) {
          querySnapshot.forEach((doc) => {
            doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
            doc.outLocalTS = moment(doc.outLocalTS).format(dateConfig.format7);
            lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
              dateConfig.format7
            );
            lastPunch.outLocalTS = moment(outLocalTS).format(
              dateConfig.format7
            );
            if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            } else if (recentPunchOut == recentPunchIn) isPass = ZERO;
            // else if (dayDiff >= 1440) {
            //   isPass = "24hrs";
            // }
            else if (
              //   recentPunchIn == doc.inLocalTS &&
              //   recentPunchIn == doc.outLocalTS
              // ) {
              //   isPass = EQUAL;
              // } else if (
              lastPunch.inLocalTS != doc.inLocalTS &&
              outLocalTS != doc.outLocalTS
            ) {
              if (
                (doc.inLocalTS > recentPunchIn &&
                  doc.inLocalTS < recentPunchOut) ||
                (doc.outLocalTS > recentPunchIn &&
                  doc.outLocalTS < recentPunchOut) ||
                (recentPunchIn > doc.inLocalTS &&
                  recentPunchIn < doc.outLocalTS) ||
                (recentPunchOut > doc.inLocalTS &&
                  recentPunchOut < doc.outLocalTS)
              ) {
                isPass = OVERLAPPING;
              }
            } else {
              if (
                isPass != NEGATIVE &&
                isPass != ZERO &&
                // isPass != "24hrs" &&
                isPass != EQUAL &&
                isPass != OVERLAPPING
              ) {
                isPass = POSITIVE;
              }
            }
          });
          if (isPass == NEGATIVE) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgNegative"));
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setDisableTransfer(false);
          } else if (isPass == EQUAL) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgEqual"));
            setAllowNavigation(false);
            setConfirmationTitleText(t("other.tlError"));
            setDisableTransfer(false);
          }
          // else if (isPass == "24hrs") {
          //   setConfirmationMsg(true);
          //   setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgDay24Hrs"));
          //   setConfirmationTitleText("Error");
          //   setAllowNavigation(false);
          //   setDisableTransfer(false);
          // }
          else if (isPass == ZERO) {
            setConfirmationMsg(true);
            setConfirmationMsgText(
              // t("pgReview.dialogueMsgs.errMsgOverlapping")
              t("pgReview.dialogueMsgs.errMsgZero")
            );
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setDisableTransfer(false);
          } else if (isPass == OVERLAPPING) {
            setConfirmationMsg(true);
            setConfirmationMsgText(
              t("pgReview.dialogueMsgs.errMsgOverlapping")
            );
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setDisableTransfer(false);
          } else {
            lastPunch.outLocalTS = outLocalTS;
            // isPersist = getActivityDetails(activityGroupOptions, activityGroup);
            updatePunch(lastPunch.punchId, lastPunch, false, isPersist)
              .then((data) => {
                console.log("data :", data);
                const newPunch = getPunch(
                  activityGroup,
                  activityName,
                  building,
                  district,
                  customerSiteVal,
                  exceptionName,
                  false,
                  jobFamily,
                  project,
                  STATUS,
                  version,
                  user.workerId,
                  actionTS,
                  outTS,
                  outLocalTS,
                  SET_EMPTY,
                  SET_EMPTY,
                  user.workerId,
                  DEVICE_DETAILS,
                  categoryPunch
                );
                if (jobProjectInfoVisible) {
                  newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
                } else if (project == " ") {
                  newPunch.jobProjectInfo = SET_EMPTY;
                }
                if (otherProjectInfoVisible) {
                  newPunch.jobProjectInfo = otherProject.trim();
                }
                if(projectInfoVisible){
                  newPunch.projectDetails = projectInfoLabel.trim();
                }else {
                  newPunch.projectDetails = SET_EMPTY;
                }
                console.log("Transfer Punch ", newPunch);
                isPersist = getActivityDetails(
                  activityGroupOptions,
                  activityGroup
                );
                addPunch(newPunch, false, isPersist)
                  .then((result) => {
                    console.log(result);
                    setConfirmationMsg(true);
                    setConfirmationMsgText(
                      t("pgReview.dialogueMsgs.msgSuccess")
                    );
                    setConfirmationTitleText(t("pgPunch.tlConfirmation"));
                    setAllowNavigation(true);
                  })
                  .catch((error) => {
                    console.log(error);
                    setDisableTransfer(false);
                  });
              })
              .catch((err) => {
                console.log(err);
                setDisableTransfer(false);
              });
          }
        } else {
          if (recentPunchOut <= recentPunchIn) {
            setConfirmationMsg(true);
            setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgNegative"));
            setConfirmationTitleText(t("other.tlError"));
            setAllowNavigation(false);
            setDisableTransfer(false);
          }
          // else if (dayDiff >= 1440) {
          //   setConfirmationMsg(true);
          //   setConfirmationMsgText(t("pgReview.dialogueMsgs.errMsgDay24Hrs"));
          //   setConfirmationTitleText("Error");
          //   setAllowNavigation(false);
          //   setDisableTransfer(false);
          // }
          else {
            lastPunch.outLocalTS = outLocalTS;
            // isPersist = getActivityDetails(activityGroupOptions, activityGroup);
            updatePunch(lastPunch.punchId, lastPunch, false, isPersist)
              .then((data) => {
                console.log("data", data);
                const newPunch = getPunch(
                  activityGroup,
                  activityName,
                  building,
                  district,
                  customerSiteVal,
                  exceptionName,
                  false,
                  jobFamily,
                  project,
                  STATUS,
                  version,
                  user.workerId,
                  actionTS,
                  outTS,
                  outLocalTS,
                  SET_EMPTY,
                  SET_EMPTY,
                  user.workerId,
                  DEVICE_DETAILS,
                  categoryPunch
                );
                if (jobProjectInfoVisible) {
                  newPunch.jobProjectInfo = jobProjectInfoLabel.trim();
                } else if (project == " ") {
                  newPunch.jobProjectInfo = SET_EMPTY;
                }
                if (otherProjectInfoVisible) {
                  newPunch.jobProjectInfo = otherProject.trim();
                }
                console.log("Transfer Punch ", newPunch);
                isPersist = getActivityDetails(
                  activityGroupOptions,
                  activityGroup
                );
                addPunch(newPunch, false, isPersist)
                  .then((result) => {
                    console.log(result);
                    setConfirmationMsg(true);
                    setConfirmationMsgText(
                      t("pgReview.dialogueMsgs.msgSuccess")
                    );
                    setConfirmationTitleText(t("pgPunch.tlConfirmation"));
                    setAllowNavigation(true);
                  })
                  .catch((error) => {
                    console.log(error);
                    setDisableTransfer(false);
                  });
              })
              .catch((err) => {
                console.log(err);
                setDisableTransfer(false);
              });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setDisableTransfer(false);
      });
  };

  const closeModalConfirmationMsg = () => {
    setConfirmationMsg(false);
    if (allowNavigation === false) {
      console.log("allowNavigation", allowNavigation)
      //history.push(PUNCH);
    } else {
      // history.push(ROOT);
     history.goBack();
    }
    // history.push(ROOT);
  };

  const closeModalExceptionTimeStamp = () => {
    setDisableExceptionLoader(false);
    if (lastPunchClock) {
      let inTS = new Date(lastPunchClock);
      let newMin = new Date(
        inTS.getUTCFullYear(),
        inTS.getMonth(),
        inTS.getUTCDate()
      );
      isVisibleMissedClockIn?setExceptionDate(new Date()):setExceptionDate(new Date(newMin));
    }
    setExceptionTime(new Date());
    setModalExceptionTimeStamp(false);
    
  };

  const saveExceptionTimeStamp = () => {
    // console.log("saved date: ", moment(exceptionDate).format(dateConfig.format3));
    // console.log("saved time: ", moment(exceptionTime).format(timeConfig.format2));

    setDisableException(true);
    setDisableExceptionLoader(true);
    if (isVisibleMissedClockIn === true) {
      //      const jobProjectInfo = getJobProjectInfo(specialProject);
      const inTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      ).toISOString();

      let inLocalTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      );
      inLocalTS = moment(inLocalTS).format(dateConfig.format4);

      const actionTS = new Date().toISOString();
      const activityName = CLOCK_IN;
      const exceptionName = MISSED_CLOCK_IN;
      const version = getUniqueID();
      const outTS = SET_EMPTY;
      const outLocalTS = SET_EMPTY;
      const customerSiteVal = getCustomerSite(customerSite);
      const punch = getPunch(
        activityGroup,
        activityName,
        building,
        district,
        customerSiteVal,
        exceptionName,
        true,
        jobFamily,
        project,
        STATUS,
        version,
        user.workerId,
        actionTS,
        inTS,
        inLocalTS,
        outTS,
        outLocalTS,
        user.workerId,
        DEVICE_DETAILS,
        categoryPunch
      );

      console.log("Exception Punch ", punch);

      // if (jobProjectInfoVisible && specialProject == SET_EMPTY) {
      //   setErrProjectInfoEntry(true);
      //   setDisableException(false);
      //   console.log("can not add record as there are errors on form");
      //   return; // come out and prevent adding punch
      // }
      if(projectInfoVisible){
        punch.projectDetails = projectInfoLabel.trim();
      }else {
        punch.projectDetails = SET_EMPTY;
      }
      if (customerSiteVisible && customerSite == SET_EMPTY) {
        setErrCustomerSite(true);
        setDisableException(false);
        setDisableExceptionLoader(false);
        return;
      }

      const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
      let isPass = "";
      let action = "";
      let punchstatus = "";
      getNewWorkerPunchRecords(
        punch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(startdate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          punchstatus = MISSEDCLOCKIN;
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
              doc.outLocalTS = moment(doc.outLocalTS).format(
                dateConfig.format7
              );
              if (
                recentPunchIn > doc.inLocalTS &&
                recentPunchIn < doc.outLocalTS
              ) {
                isPass = OVERLAPPING;
              } else if (recentPunchIn == doc.inLocalTS) {
                isPass = EQUAL;
              } else {
                if (isPass != OVERLAPPING && isPass != EQUAL) {
                  isPass = POSITIVE;
                  action = ADD;
                }
              }
            });
          } else {
            isPass = POSITIVE;
            action = ADD;
          }
          if (jobProjectInfoVisible) {
            punch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            punch.jobProjectInfo = SET_EMPTY;
          }
          if (otherProjectInfoVisible) {
            punch.jobProjectInfo = otherProject.trim();
          }
          getValidationScenarios(isPass, action, punch, {}, punchstatus);
        })
        .catch((error) => {
          console.log(error);
          setDisableException(false);
          setDisableExceptionLoader(false);
        });
    } else if (isVisibleMissedClockOut === true) {
      //      const jobProjectInfo = getJobProjectInfo(specialProject);
      //    console.log("jobProjectInfo :", jobProjectInfo);
      setmissedClockOutMeal(true);
      const outTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      ).toISOString();

      let outLocalTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      );
      outLocalTS = moment(outLocalTS).format(dateConfig.format4);

      const actionTS = new Date().toISOString();

      const activityName = CLOCK_OUT;
      const exceptionName = MISSED_CLOCK_OUT;
      const punch = getPunch(
        lastPunch.activityGroup,
        activityName,
        lastPunch.buildingId,
        lastPunch.districtId,
        lastPunch.customerSite ? lastPunch.customerSite : customerSite,
        exceptionName,
        true,
        lastPunch.jobName,
        lastPunch.jobProjectInfo,
        lastPunch.status,
        lastPunch.version,
        lastPunch.workerId,
        actionTS,
        lastPunch.inTS,
        lastPunch.inLocalTS,
        outTS,
        outLocalTS,
        user.workerId,
        DEVICE_DETAILS,
        categoryPunch
      );

      if(projectInfoVisible){
        punch.projectDetails = projectInfoLabel.trim();
      }else {
        punch.projectDetails = SET_EMPTY;
      }
      console.log("MISSED CLOCK OUT", punch);

      const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(punch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
      const recentPunchOut = moment(punch.outLocalTS).format(
        dateConfig.format7
      );
      let isPass = "";
      let action = "";
      let punchstatus = "";
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        punch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          punchstatus = MISSEDCLOCKOUT;
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
              doc.outLocalTS = moment(doc.outLocalTS).format(
                dateConfig.format7
              );
              lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
                dateConfig.format7
              );
              lastPunch.outLocalTS = moment(lastPunch.outLocalTS).format(
                dateConfig.format7
              );
              if (recentPunchOut == recentPunchIn) {
                isPass = ZERO;
              } else if (recentPunchOut < recentPunchIn) {
                isPass = NEGATIVE;
              }
              // else if (dayDiff >= 1440) {
              //   isPass = DAY24HRS;
              // }
              else if (
                //   recentPunchIn == doc.inLocalTS &&
                //   recentPunchOut == doc.outLocalTS
                // ) {
                //   isPass = EQUAL;
                // } else if (
                lastPunch.inLocalTS != doc.inLocalTS &&
                lastPunch.outLocalTS != doc.outLocalTS
              ) {
                if (
                  (doc.inLocalTS > recentPunchIn &&
                    doc.inLocalTS < recentPunchOut) ||
                  (doc.outLocalTS > recentPunchIn &&
                    doc.outLocalTS < recentPunchOut) ||
                  (recentPunchIn > doc.inLocalTS &&
                    recentPunchIn < doc.outLocalTS) ||
                  (recentPunchOut > doc.inLocalTS &&
                    recentPunchOut < doc.outLocalTS)
                ) {
                  isPass = OVERLAPPING;
                }
              } else {
                if (
                  isPass != ZERO &&
                  isPass != NEGATIVE &&
                  // isPass != DAY24HRS &&
                  isPass != OVERLAPPING &&
                  isPass != EQUAL
                ) {
                  isPass = POSITIVE;
                  action = UPDATE;
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            }
            // else if (dayDiff >= 1440) {
            //   isPass = DAY24HRS;
            // }
            else {
              if (
                isPass != ZERO &&
                // isPass != DAY24HRS &&
                isPass != NEGATIVE
              ) {
                isPass = POSITIVE;
                action = UPDATE;
              }
            }
          }
          if (jobProjectInfoVisible) {
            punch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            punch.jobProjectInfo = SET_EMPTY;
          }
          if (otherProjectInfoVisible) {
            punch.jobProjectInfo = otherProject.trim();
          }
          getValidationScenarios(isPass, action, punch, lastPunch, punchstatus);
          //setDisableExceptionLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setDisableException(false);
          setDisableExceptionLoader(false);
        });
    }
  };

  const validateMissedClockout = () => {
    setDisableException(true);
    setDisableExceptionLoader(true);

    if (isVisibleMissedClockOut === true) {
      const outTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      ).toISOString();

      let outLocalTS = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      );
      outLocalTS = moment(outLocalTS).format(dateConfig.format4);

      const actionTS = new Date().toISOString();

      const activityName = CLOCK_OUT;
      const exceptionName = MISSED_CLOCK_OUT;
      const punch = getPunch(
        lastPunch.activityGroup,
        activityName,
        lastPunch.buildingId,
        lastPunch.districtId,
        lastPunch.customerSite ? lastPunch.customerSite : customerSite,
        exceptionName,
        true,
        lastPunch.jobName,
        lastPunch.jobProjectInfo,
        lastPunch.status,
        lastPunch.version,
        lastPunch.workerId,
        actionTS,
        lastPunch.inTS,
        lastPunch.inLocalTS,
        outTS,
        outLocalTS,
        user.workerId,
        DEVICE_DETAILS,
        categoryPunch
      );

      console.log("MISSED CLOCK OUT", punch);
      if(projectInfoVisible){
        punch.projectDetails = projectInfoLabel.trim();
      }else {
        punch.projectDetails = SET_EMPTY;
      }
      const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(punch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
      const recentPunchOut = moment(punch.outLocalTS).format(
        dateConfig.format7
      );
      let isPass = "";
      let action = "";
      let punchstatus = "";
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        punch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          punchstatus = MISSEDCLOCKOUT;
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
              doc.outLocalTS = moment(doc.outLocalTS).format(
                dateConfig.format7
              );
              lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
                dateConfig.format7
              );
              lastPunch.outLocalTS = moment(lastPunch.outLocalTS).format(
                dateConfig.format7
              );
              if (recentPunchOut == recentPunchIn) {
                isPass = ZERO;
              } else if (recentPunchOut < recentPunchIn) {
                isPass = NEGATIVE;
              } else if (
                lastPunch.inLocalTS != doc.inLocalTS &&
                lastPunch.outLocalTS != doc.outLocalTS
              ) {
                if (
                  (doc.inLocalTS > recentPunchIn &&
                    doc.inLocalTS < recentPunchOut) ||
                  (doc.outLocalTS > recentPunchIn &&
                    doc.outLocalTS < recentPunchOut) ||
                  (recentPunchIn > doc.inLocalTS &&
                    recentPunchIn < doc.outLocalTS) ||
                  (recentPunchOut > doc.inLocalTS &&
                    recentPunchOut < doc.outLocalTS)
                ) {
                  isPass = OVERLAPPING;
                }
              } else {
                if (
                  isPass != ZERO &&
                  isPass != NEGATIVE &&
                  isPass != OVERLAPPING &&
                  isPass != EQUAL
                ) {
                  isPass = POSITIVE;
                  action = UPDATE;
                  setMealReminder(true);
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            } else {
              if (isPass != ZERO && isPass != NEGATIVE) {
                isPass = POSITIVE;
                action = UPDATE;
                setMealReminder(true);
              }
            }
          }
          if (jobProjectInfoVisible) {
            punch.jobProjectInfo = jobProjectInfoLabel.trim();
          } else if (project == " ") {
            punch.jobProjectInfo = SET_EMPTY;
          }
          if (otherProjectInfoVisible) {
            punch.jobProjectInfo = otherProject.trim();
          }
          if (isPass != POSITIVE) {
            setMealReminder(false);
            getValidationScenarios(
              isPass,
              action,
              punch,
              lastPunch,
              punchstatus
            );
            setDisableExceptionLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setDisableException(false);
          setDisableExceptionLoader(false);
        });
    }
  };

  const validateClockOut = () => {
    setDisableClockOut(true);

    const activityName = CLOCK_OUT;
    const exceptionName = SET_EMPTY;
    const version = getUniqueID();
    const timeStamp = new Date();
    const outTS = timeStamp.toISOString();
    const actionTS = timeStamp.toISOString();
    const outLocalTS = moment(timeStamp).format(dateConfig.format4);
    const punch = getPunch(
      lastPunch.activityGroup,
      activityName,
      lastPunch.buildingId,
      lastPunch.districtId,
      lastPunch.customerSite ? lastPunch.customerSite : customerSite,
      lastPunch.exceptionName,
      lastPunch.isException,
      lastPunch.jobName,
      lastPunch.jobProjectInfo,
      lastPunch.status,
      lastPunch.version,
      lastPunch.workerId,
      actionTS,
      lastPunch.inTS,
      lastPunch.inLocalTS,
      outTS,
      outLocalTS,
      user.workerId,
      DEVICE_DETAILS,
      categoryPunch
    );

    console.log("Clockout Punch", punch);
    if(projectInfoVisible){
      punch.projectDetails = projectInfoLabel.trim();
    }else {
      punch.projectDetails = SET_EMPTY;
    }
    console.log("Clock Out Punch" + JSON.stringify(punch));
    const startdate = moment(punch.inLocalTS).format(dateConfig.format6);
    const endDate = moment(punch.outLocalTS).format(dateConfig.format6);
    const recentPunchIn = moment(punch.inLocalTS).format(dateConfig.format7);
    const recentPunchOut = moment(punch.outLocalTS).format(dateConfig.format7);
    let isPass = "";
    let action = "";
    let punchstatus = "";
    const dayDiff = parseInt(
      moment
        .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
        .asMinutes()
    );
    console.log("DayDIff......." + dayDiff);
    getNewWorkerPunchRecords(
      punch.workerId,
      moment(startdate).subtract(1, "days").format(dateConfig.format4),
      moment(endDate).add(1, "days").format(dateConfig.format4)
    )
      .then((querySnapshot) => {
        console.log("querySnapshot....." + JSON.stringify(querySnapshot));
        punchstatus = CLOCKOUT;
        if (querySnapshot != undefined && querySnapshot.length > 0) {
          querySnapshot.forEach((doc) => {
            doc.inLocalTS = moment(doc.inLocalTS).format(dateConfig.format7);
            doc.outLocalTS = moment(doc.outLocalTS).format(dateConfig.format7);
            lastPunch.inLocalTS = moment(lastPunch.inLocalTS).format(
              dateConfig.format7
            );
            lastPunch.outLocalTS = moment(lastPunch.outLocalTS).format(
              dateConfig.format7
            );
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            } else if (
              lastPunch.inLocalTS != doc.inLocalTS &&
              lastPunch.outLocalTS != doc.outLocalTS
            ) {
              if (
                (doc.inLocalTS > recentPunchIn &&
                  doc.inLocalTS < recentPunchOut) ||
                (doc.outLocalTS > recentPunchIn &&
                  doc.outLocalTS < recentPunchOut) ||
                (recentPunchIn > doc.inLocalTS &&
                  recentPunchIn < doc.outLocalTS) ||
                (recentPunchOut > doc.inLocalTS &&
                  recentPunchOut < doc.outLocalTS)
              ) {
                isPass = OVERLAPPING;
              }
            } else {
              if (
                isPass != NEGATIVE &&
                isPass != ZERO &&
                isPass != OVERLAPPING &&
                isPass != EQUAL
              ) {
                isPass = POSITIVE;
                action = UPDATE;
                setMealReminder(true);
              }
            }
          });
        } else {
          if (recentPunchOut == recentPunchIn) {
            isPass = ZERO;
          } else if (recentPunchOut < recentPunchIn) {
            isPass = NEGATIVE;
          } else {
            if (isPass != ZERO && isPass != NEGATIVE) {
              isPass = POSITIVE;
              action = UPDATE;
              setMealReminder(true);
            }
          }
        }
        if (jobProjectInfoVisible) {
          punch.jobProjectInfo = jobProjectInfoLabel.trim();
        } else if (project == " ") {
          punch.jobProjectInfo = SET_EMPTY;
        }
        if (otherProjectInfoVisible) {
          punch.jobProjectInfo = otherProject.trim();
        }
        if (isPass != POSITIVE) {
          setMealReminder(false);
          getValidationScenarios(isPass, action, punch, lastPunch, punchstatus);
        }
      })
      .catch((error) => {
        console.log(error);
        setDisableClockOut(false);
      });
  };

  const getValidationScenarios = (
    isPass,
    action,
    punch,
    lastPunch,
    punchstatus
  ) => {
    console.log("getValidationScenarios called ..........");
    switch (isPass) {
      case NEGATIVE:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgNegative"),
          t("other.tlError"),
          false,
          punchstatus
        );
        break;
      case ZERO:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgZero"),
          t("other.tlError"),
          false,
          punchstatus
        );
        break;
      case EQUAL:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgEqual"),
          t("other.tlError"),
          false,
          punchstatus
        );
        break;
      // case DAY24HRS:
      //   setFlag(
      //     true,
      //     t("pgReview.dialogueMsgs.errMsgDay24Hrs"),
      //     "Error",
      //     false,
      //     punchstatus
      //   );
      //   break;
      case OVERLAPPING:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgOverlapping"),
          t("other.tlError"),
          false,
          punchstatus
        );
        break;
      case POSITIVE:
        console.log(POSITIVE + isPass);
        if (action == ADD) {
          isPersist = getActivityDetails(activityGroupOptions, activityGroup);
          addPunch(punch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true,
                {}
              );
            })
            .catch((error) => {
              console.log(error);
              getStatus(punchstatus);
            });
        } else {
          isPersist = getActivityDetails(activityGroupOptions, activityGroup);
          updatePunch(lastPunch.punchId, punch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true,
                {}
              );
            })
            .catch((error) => {
              console.log(error);
              getStatus(punchstatus);
            });
        }
        break;
      default:
        console.log("default" + isPass);
        if (action == ADD) {
          isPersist = getActivityDetails(activityGroupOptions, activityGroup);
          addPunch(punch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true,
                {}
              );
            })
            .catch((error) => {
              console.log(error);
              getStatus(punchstatus);
            });
        } else {
          isPersist = getActivityDetails(activityGroupOptions, activityGroup);
          updatePunch(lastPunch.punchId, punch, false, isPersist)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                t("pgPunch.tlConfirmation"),
                true,
                {}
              );
            })
            .catch((error) => {
              console.log(error);
              getStatus(punchstatus);
            });
        }
        break;
    }
  };
  const setFlag = (msg, txt, titletxt, navigate, punchstatus) => {
    setConfirmationMsg(msg);
    setConfirmationMsgText(txt);
    setConfirmationTitleText(titletxt);
    setAllowNavigation(navigate);
    getStatus(punchstatus);
  };
  const getStatus = (punchstatus) => {
    if (punchstatus == CLOCKIN) {
      setDisableClockIn(false);
    } else if (punchstatus == CLOCKOUT) {
      setDisableClockOut(false);
    } else if (punchstatus == MISSEDCLOCKIN || punchstatus == MISSEDCLOCKOUT) {
      setDisableException(false);
      setDisableExceptionLoader(false);
      closeModalExceptionTimeStamp();
    }
  };

  const missedClockIn = () => {
    setModalExceptionTimeStamp(true);
  };

  const missedClockOut = () => {
    console.log("meal before", missedClockOutMeal);
    setmissedClockOutMeal(true);
    setModalExceptionTimeStamp(true);
    console.log("meal after", missedClockOutMeal);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const historyHandler = () => {
    getPreviousPunches(user.workerId).then((querySnapshot) => {
      // console.log("Queries: ", JSON.stringify(querySnapshot));
      setPunchHistoryDetails([]);
      setDataLoaded(true);
      if (querySnapshot) {
        querySnapshot.forEach((doc) => {
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            console.log(
              "Details",
              doc.id,
              doc.inLocalTS,
              doc.outLocalTS,
              doc.jobName,
              doc.status
            );
            setPunchHistoryDetails((previous) => [
              ...previous,
              {
                // id:id+1,
                ...doc,
              },
            ]);
          }
        });
      }
      setDialogOpen(true);
    });
  };

  const handleWeekHoursClose = () => {
    setWeekHoursDiagolueOpen(false);
  };

  const weekHoursHandler = () => {
    const weekNumber = getWeekNumber(new Date());

    if (!weekHoursDataLoaded) {
      getWeekHoursDetails(user.workerId, weekNumber).then((querySnapshot) => {
        const dayOrder = [
          { day: t("other.dscLblSunday"), hours: "00.00" },
          { day: t("other.dscLblMonday"), hours: "00.00" },
          { day: t("other.dscLblTuesday"), hours: "00.00" },
          { day: t("other.dscLblWednesday"), hours: "00.00" },
          { day: t("other.dscLblThursday"), hours: "00.00" },
          { day: t("other.dscLblFriday"), hours: "00.00" },
          { day: t("other.dscLblSaturday"), hours: "00.00" },
        ];
        setWeekHoursDetails(dayOrder);

        if (querySnapshot) {
          dayOrder.forEach((day, index) => {
            querySnapshot.forEach((doc) => {
              if (day.day === t("other.dscLbl" + doc.day)) {
                const hours = getHoursFormat(doc.hours);
                dayOrder[index] = {
                  day: t("other.dscLbl" + doc.day),
                  hours: hours,
                };
              }
            });
          });
        }
        setWeekHoursDetails(dayOrder);
        setWeekHoursDataLoaded(true);
      });
    }

    console.log(weekHoursDetails);
    setWeekHoursDiagolueOpen(true);
  };

  useEffect(() => {
    try {
      let building;
      if (lastPunchLoadFlag) {
        //building = lastPunch.buildingId;
        //  setBuilding(building);
        setDefaultValue(
          buildingOptions,
          lastPunch.buildingId,
          defaultDistrict[0].buildings[0].value,
          setBuilding
        );
        setLastPunchLoadFlag(false);
      } else {
        building = buildingOptions[0].value;
        setBuilding(building);
      }

      if (building === CUSTOMER_SITE) {
        setCustomerSiteVisible(true);
      }
    } catch (error) {
      console.error(error);
    }
  }, [buildingOptions]);

  const handleChangeCustomerSite = (event) => {
    const value = event.target.value;
    setCustomerSite(value);
    if (value.length === 0) {
      setErrCustomerSite(true);
    } else {
      setErrCustomerSite(false);
    }
  };

  useEffect(() => {
    if (!user.firstName) {
      console.log("No user found! Please verify your employee ID");
      history.push("/");
    }
    if (appConfig != null && appConfig.activityGroups == null) {
      dispatch(getPunchLoading());
      dispatch(getActivityGroups());
    }
    if (appConfig != null && appConfig.jobFamilies == null) {
      dispatch(getJobFamilies());
    }
    // if (appConfig != null && appConfig.locations == null) {
    //   dispatch(getLocations());
    // }

    // if (appConfig !== null && appConfig.locations !== null) {
    //   setDistrict(districtOptions[0].value);
    //   setBuildingOptions(districtOptions[0].buildings);
    // }
  }, [appConfig]);

  useEffect(() => {
    if (user && user.workerId) {
      if (user.country === "testCountry") {
        user.countryCode = user.country;
      }
      if (user.countryCode || user.alternateCountryCode) {
        dispatch(getLocations(user.countryCode, user.alternateCountryCode));
        //dispatch(getLocations(user.alternateCountryCode));
      }
    }
  }, [user]);

  // console.log("dist",districtOptions)

  //Saving dropdown values
  const getSavedDropdowns = (lastPunch) => {
    if (lastPunch !== null) {
      setDefaultValue(
        districtOptions,
        lastPunch.districtId,
        districtOptions[0].value,
        setDistrict
      );
      let buildings = getBuildings(lastPunch.districtId, districtOptions);
      if (buildings) {
        setLastPunchLoadFlag(true);
        setBuildingOptions(buildings);
        setDefaultValue(
          buildings,
          lastPunch.buildingId,
          defaultDistrict[0].buildings[0].value,
          setBuilding
        );
      }
      setDefaultValue(
        jobFamiliesOptions,
        lastPunch.jobName,
        defaultDistrict[0].buildings[0].value,
        setJobFamily
      );
      setDefaultValue(
        activityGroupOptions.filter((item) => !item.mgrOnly),
        lastPunch.activityGroup,
        defaultAG[0].value,
        setActivityGroup
      );
      if (lastPunch.activityGroup === MEAL && lastPunch.status != "deleted") {
        if (user.lastActGrp && user.lastActGrp != MEAL) {
          setActivityGroup(user.lastActGrp);
        } else {
          setActivityGroup(defaultAG[0].value);
        }
      }

      if (lastPunch.activityName === CLOCK_OUT) {
        if (user.jobRole === undefined || user.jobRole === "") {
          setJobFamily(-1);
        } else {
          setJobFamily(user.jobRole);
        }
      }
      if(lastPunch.projectDetails != undefined && jobFamily !=-1 && specialProjects){
        console.log('25::4', lastPunch.projectDetails);
        let jobRoleRecord = specialProjects.filter(
          (item) => item.value === jobFamily
        );
        if(jobRoleRecord && jobRoleRecord[0] && jobRoleRecord[0].projectInfoEntryType ==='id'){
          if(lastPunch.projectDetails ===SET_EMPTY || lastPunch.projectDetails){
            setprojectInfoVisible(true);
            setprojectInfoLabel(lastPunch.projectDetails);
          }
        }else {
          setprojectInfoLabel(SET_EMPTY);
          setprojectInfoVisible(false);
        }
          
      }
    
    }
  };
  useEffect(() => {
    getSavedDropdowns(lastPunch);
  }, [lastPunch, appConfig.locations]);

  useEffect(() => {
    getSavedDropdowns(lastPunch);

    // if last activity is clock in or transfer
    // then disable transfer and enable clock out
    if (lastPunch && lastPunch.activityName) {
      if (
        lastPunch.activityName === CLOCK_IN ||
        lastPunch.activityName === TRANSFER
      ) {
        if (validateEntries(district, building, jobFamily, activityGroup) 
        && validateProject(activityGroup,project,jobProjectInfoVisible,jobProjectInfoLabel,otherProjectInfoVisible,otherProject)) {
          setDisableClockOut(false);
        }
        setDisableTransfer(true);
      }

      // if last activity was clock out then disable clock out button
      if (lastPunch.activityName === CLOCK_OUT) {
        setDisableClockOut(true);
      }

      // if (lastPunch.activityGroup == PROJECT) {
      //   setJobProjectInfoVisible(true);
      //   if (lastPunch.jobProjectInfo) {
      //     setSpecialProject(lastPunch.jobProjectInfo);
      //   }
      // } else {
      //   setJobProjectInfoVisible(false);
      //   setSpecialProject(SET_EMPTY);
      // }
      if(jobFamily && jobFamily !=-1 && lastPunch.projectDetails ===projectInfoLabel && !projectInfoVisible){
        setprojectInfoVisible(true);
      }
      if (lastPunch.buildingId === CUSTOMER_SITE) {
        setCustomerSiteVisible(true);
        if (lastPunch.customerSite) {
          setCustomerSite(lastPunch.customerSite);
        }
      } else {
        setCustomerSiteVisible(false);
      }
    }
  }, [lastPunch]);
  const minDateHandler = (lastPunchClock) => {
    //console.log("hereeee");
    let currStartDate = new Date(
      moment(new Date()).subtract(2, "weeks").startOf("weeks")
    );
    let TS;
    if (lastPunchClock) {
      let startDate = moment(currStartDate).format(dateConfig.format6);
      let minhDate = moment(lastPunchClock).format(dateConfig.format6);

      if (startDate > minhDate) {
        console.log(
          "CURR DATE:1" + startDate + " START DATE" + minhDate + "DIFFF"
        );
        TS = currStartDate;
      } else {
        console.log(
          "CURR DATE:2" + startDate + " START DATE" + minhDate + "DIFFF"
        );
        TS = minhDate;
      }
    } else {
      TS = currStartDate;
    }
    console.log("CURR DATE:" + TS);
    return TS;
  };

  // En able or Disable Transfer button logic
  // if current job family, activity group, building id, district id is as same as
  // last punch record then disable transfer and enable clock out
  useEffect(() => {
    let lastPunchDate = new Date(minDateHandler(lastPunchClock));
    if (lastPunch && lastPunch.activityName) setExceptionDate(lastPunchDate);
    else setExceptionDate(new Date());

    if(isVisibleMissedClockIn){
      setExceptionDate(new Date());
    }
    if(lastPunch){
      console.log('validate cond:',
      (lastPunch.projectDetails ===undefined ||  (projectInfoVisible?lastPunch.projectDetails ===projectInfoLabel:true) ));
    }
    
    if (
      lastPunch &&
      lastPunch.activityName &&
      lastPunch.jobName === jobFamily &&
      lastPunch.activityGroup === activityGroup &&
      lastPunch.buildingId === building &&
      lastPunch.districtId === district &&
      (lastPunch.jobProjectInfo === project ||
        (lastPunch.jobProjectInfo === SET_EMPTY &&
          project === " " &&
          !jobProjectInfoVisible) ||
        (lastPunch.jobProjectInfo === jobProjectInfoLabel &&
          jobProjectInfoVisible) ||
          (lastPunch.jobProjectInfo === otherProject &&
            otherProjectInfoVisible)
          ) &&
      // (lastPunch.activityGroup != PROJECT ||
      //   (lastPunch.activityGroup === PROJECT &&
      //     lastPunch.jobProjectInfo === specialProject)) &&
      //    (lastPunch.jobProjectInfo === project || (lastPunch.jobProjectInfo==jobProjectInfoLabel && jobProjectInfoVisible) ) &&
      (!lastPunch.customerSite ||
        (lastPunch.customerSite && lastPunch.customerSite === customerSite)) &&
         
        (lastPunch.projectDetails ===undefined ||  (projectInfoVisible?lastPunch.projectDetails ===projectInfoLabel:true) )
   
    ) {
      setDisableTransfer(true);
      if (validateEntries(district, building, jobFamily, activityGroup) 
      && validateProject(activityGroup,project,jobProjectInfoVisible,jobProjectInfoLabel,otherProjectInfoVisible,otherProject))
        setDisableClockOut(false);
    } else {
      if (
        lastPunch &&
        lastPunch.activityName &&
        lastPunch.activityName !== CLOCK_OUT
      ) {
        if (validateEntries(district, building, jobFamily, activityGroup)
        && validateProject(activityGroup,project,jobProjectInfoVisible,jobProjectInfoLabel,otherProjectInfoVisible,otherProject)) {
          setDisableTransfer(false);
        } else {
          setDisableTransfer(true);
        }
      }
      setDisableClockOut(true);
    }

    if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      setDisableClockOut(true);
    }

    // if (specialProject.length > 0) {
    //   setErrProjectInfoEntry(false);
    // } else {
    //   setErrProjectInfoEntry(true);
    // }

    if (customerSite && customerSite.length > 0) {
      setErrCustomerSite(false);
    } else {
      setErrCustomerSite(true);
    }
  }, [
    district,
    building,
    jobFamily,
    activityGroup,
    specialProject,
    customerSite,
    project,
    jobProjectInfoLabel,
    projectInfoLabel,
    projectInfoVisible,
    otherProjectInfoVisible,
    otherProject,
  ]);

  const validateProject = (
    activityGroup,
    project,
    jobProjectInfoVisible,
    jobProjectInfoLabel,
    otherProjectInfoVisible,
    otherProject,
    
  ) => {
    if(activityGroup !=-1){
      if(activityGroup ===PROJECT){
        if(jobProjectInfoVisible && 
          (jobProjectInfoLabel ===SET_EMPTY || jobProjectInfoLabel ===defaultProject[0].value)){
          return false;
        }else if(!jobProjectInfoVisible && project === defaultProject[0].value ||
          project ===SET_EMPTY){
            return false;
        }else{
          if((otherProjectInfoVisible && !otherProject) ||(otherProjectErr)){
            return false;
          }else return true;
        } 
      }else {
        return true;
      }
    }else return false;
  }
  // for user who is recently registered and no lastPunch details
  useEffect(() => {
    // disable clock in button as user need to provide input
    if (lastPunch === undefined || lastPunch === null) {
      setDisableClockIn(true);
    }
    if(project && project != defaultProject[0].value
      && project ==='Other'){
      setOtherProjectInfoVisible(true);
    }else {
      setOtherProjectInfoVisible(false);
    }

    // enable clock in button if user changes all inputs
    if (validateEntries(district, building, jobFamily, activityGroup)
    && validateProject(activityGroup,project,jobProjectInfoVisible,jobProjectInfoLabel,otherProjectInfoVisible,otherProject)) {
      setDisableClockIn(false);
    } else {
      setDisableClockIn(true);
    }
    if(jobFamily && jobFamily !=-1 && !projectInfoVisible){
      let jobRoleRecord = jobFamiliesOptions.filter(
        (item) => item.value === jobFamily
      );
      if(jobRoleRecord && jobRoleRecord[0] && jobRoleRecord[0].projectInfoEntryType ==='id'){
        setprojectInfoVisible(true);
      }
      
    }
    
  }, [district, building, jobFamily, activityGroup, project, jobProjectInfoLabel, otherProjectInfoVisible,otherProject]);

  // 64 - set exception date to lastPunchClock Date which is lastPunch.activityTS
  useEffect(() => {
    let inTS = new Date(lastPunchClock);
    let newMin = new Date(
      inTS.getUTCFullYear(),
      inTS.getMonth(),
      inTS.getUTCDate()
    );

    //if (lastPunch && lastPunch.activityName) setExceptionDate(new Date(newMin));
  }, [lastPunch]);

  useEffect(() => {
    let lastactivity = LAST + activityGroup;
    projectOptions = getProjectsByActivityGroup(
      appConfig.projects,
      activityGroup,
      defaultActivity,
      defaultProject,
      defaultLeave,
      jobFamily,
      district
    );
    if (lastPunch) {
      // const i = projectOptions.find((item) => lastPunch.jobProjectInfo === item.value);
      //       if(activityGroup ===PROJECT && !i){
      //         projectOptions.push({ label: lastPunch.jobProjectInfo, value: lastPunch.jobProjectInfo });
      //       }
      if (lastPunch.activityGroup == activityGroup &&
        lastPunch.jobName == jobFamily) {
        if (projectOptions.length <= 1) {
          setJobProjectInfoVisible(true);
          setJobProjectInfoLabel(lastPunch.jobProjectInfo);
          setProjectValue(defaultProject[0].value);
        } else {
          setJobProjectInfoLabel(SET_EMPTY);
          setJobProjectInfoVisible(false);
          // setDefaultValue(
          //   projectOptions,
          //   lastPunch.jobProjectInfo,
          //   projectOptions[0].value,
          //   setProjectValue
          // );
          if(lastPunch.jobProjectInfo){
            const i = projectOptions.find((item) => lastPunch.jobProjectInfo === item.value);
            if(activityGroup ===PROJECT && !i){
              setProjectValue('Other');
              setOtherProjectInfoVisible(true);
              setOtherProject(lastPunch.jobProjectInfo);
            }else {
              setDefaultValue(
                projectOptions,
                lastPunch.jobProjectInfo,
                projectOptions[0].value,
                setProjectValue
              );
            }
          }else {
            setProjectValue(projectOptions[0].value);
          }
         
         
        }
      } else {
        if (projectOptions.length <= 1) {
          setJobProjectInfoVisible(true);
          if (user && user[lastactivity]) {
            setProjectValue(defaultProject[0].value);
            setJobProjectInfoLabel(user[lastactivity]);
          } else {
            setJobProjectInfoLabel(SET_EMPTY);
            setProjectValue(defaultProject[0].value);
          }
        } else {
          setJobProjectInfoLabel(SET_EMPTY);
          setJobProjectInfoVisible(false);
          if (user && user[lastactivity]) {
            const i = projectOptions.find((item) => user[lastactivity] === item.value);
            if(activityGroup ===PROJECT && !i){
              setProjectValue('Other');
              setOtherProjectInfoVisible(true);
              setOtherProject(lastPunch.jobProjectInfo);
            }else {
              setDefaultValue(
                projectOptions,
                user[lastactivity],
                projectOptions[0].value,
                setProjectValue
              );
            }
          } else {
            setProjectValue(defaultActivity[0].value);
          }
        }
      }
      let specialProject;
      if(jobFamily && jobFamily !=-1){
        let jobRoleRecord = jobFamiliesOptions.filter(
          (item) => item.value === jobFamily
        );
        if(jobRoleRecord && jobRoleRecord[0] &&  jobRoleRecord[0].projectInfoEntryType ==='id'){
          specialProject = jobFamily;
          setprojectInfoVisible(true);
       
        }
        console.log('specialProject:', specialProject);
        if(lastPunch.projectDetails !=undefined){

          if(specialProject !=undefined){
            setprojectInfoVisible(true);
            setprojectInfoLabel(lastPunch.projectDetails);
          }else {
            setprojectInfoVisible(false);
          }
           
        } 
        
      }
      
    } else if (user[lastactivity]) {
      if (projectOptions.length <= 1) {
        setJobProjectInfoVisible(true);
        setJobProjectInfoLabel(user[lastactivity]);
        setProjectValue(defaultProject[0].value);
      } else {
        setJobProjectInfoVisible(false);
        setDefaultValue(
          projectOptions,
          user[lastactivity],
          defaultActivity[0].value,
          setProjectValue
        );
      }
    } else {
      if (projectOptions.length <= 1) {
        setJobProjectInfoVisible(true);
        setJobProjectInfoLabel(SET_EMPTY);
        setProjectValue(defaultProject[0].value);
      } else {
        setJobProjectInfoVisible(false);
        setProjectValue(defaultActivity[0].value);
      }
    }
  }, [activityGroup, lastPunch, appConfig.projects ,jobFamily]);

  // 75 - enable / disable save button in case of Exception Punch
  useEffect(() => {
    toggleDisableException(
      exceptionDate,
      exceptionTime,
      setDisableException,
      setDisableForTime,
      setHelperTextForFutureTime,
      lastPunchClock
    );
  }, [exceptionDate, exceptionTime]);
  useEffect(()=>{
    if(activityGroup !=-1){
      const i = activityGroupOptions.find((item) => activityGroup === item.value);
      if(!i){
        setActivityGroup(defaultAG[0].value);
      }

    }
  })
  return (
    <PunchView
      back={back}
      user={user}
      lastPunch={lastPunch}
      lastPunchStatus={lastPunchStatus}
      lastPunchTime={lastPunchTime}
      lastPunchClock={lastPunchClock}
      t={t}
      districtOptions={districtOptions}
      district={district}
      districtChange={districtChange}
      buildingOptions={buildingOptions}
      building={building}
      buildingChange={buildingChange}
      jobFamiliesOptions={jobFamiliesOptions}
      jobFamily={jobFamily}
      jobFamilyChange={jobFamilyChange}
      activityGroupOptions={activityGroupOptions}
      activityGroup={activityGroup}
      activityGroupChange={activityGroupChange}
      clockIn={clockIn}
      clockOut={clockOut}
      transfer={transfer}
      mealStart={mealStart}
      missedClockIn={missedClockIn}
      missedClockOut={missedClockOut}
      isVisibleMissedClockIn={isVisibleMissedClockIn}
      isVisibleMissedClockOut={isVisibleMissedClockOut}
      isVisibleTransfer={isVisibleTransfer}
      isVisibleClockIn={isVisibleClockIn}
      isDisabledClockOut={disableClockOut}
      isDisabledClockIn={disableClockIn}
      isDisableException={disableException}
      isDisableExceptionLoader={disableExceptionLoader}
      setDisableExceptionLoader = {setDisableExceptionLoader}
      modalExceptionTimeStamp={modalExceptionTimeStamp}
      closeModalExceptionTimeStamp={closeModalExceptionTimeStamp}
      saveExceptionTimeStamp={saveExceptionTimeStamp}
      exceptionDate={exceptionDate}
      handleExceptionDateChange={handleExceptionDateChange}
      exceptionTime={exceptionTime}
      handleExceptionTimeChange={handleExceptionTimeChange}
      confirmationMsg={confirmationMsg}
      confirmationTitleText={confirmationTitleText}
      allowNavigation={allowNavigation}
      closeModalConfirmationMsg={closeModalConfirmationMsg}
      confirmationMsgText={confirmationMsgText}
      specialProjectDialog={specialProjectDialog}
      specialProject={specialProject}
      handleChangeSpecialProject={handleChangeSpecialProject}
      isDisabledSpecialProjectOK={isDisabledSpecialProjectOK}
      okSpecialProjectDialog={okSpecialProjectDialog}
      cancelSpecialProjectDialog={cancelSpecialProjectDialog}
      jobProjectInfoLabel={jobProjectInfoLabel}
      isDisabledTransfer={disableTransfer}
      jobProjectInfoVisible={jobProjectInfoVisible}
      projectInfoLabel={projectInfoLabel}
      projectInfoVisible={projectInfoVisible}
      handleOtherProjectDetails ={handleOtherProjectDetails}
      otherProjectInfoVisible={otherProjectInfoVisible}
      otherProject={otherProject}
      otherProjectErr ={otherProjectErr}
      handleChangeProjectDetails={handleChangeProjectDetails}
      errProjectInfoEntry={errProjectInfoEntry}
      customerSite={customerSite}
      errCustomerSite={errCustomerSite}
      customerSiteVisible={customerSiteVisible}
      handleChangeCustomerSite={handleChangeCustomerSite}
      helperTextForFutureTime={helperTextForFutureTime}
      disableForTime={disableForTime}
      // for activity history
      historyHandler={historyHandler}
      dialogOpen={dialogOpen}
      handleDialogOpen={handleDialogOpen}
      handleDialogClose={handleDialogClose}
      punchHistoryDetails={punchHistoryDetails}
      weekHoursDiagolueOpen={weekHoursDiagolueOpen}
      weekHoursDetails={weekHoursDetails}
      weekHoursHandler={weekHoursHandler}
      handleWeekHoursClose={handleWeekHoursClose}
      weekHoursDataLoaded={weekHoursDataLoaded}
      project={project}
      projectOptions={projectOptions}
      projectGroupHandler={projectGroupHandler}
      mealStartProgress={mealStartProgress}
      mealReminderHandler={mealReminderHandler}
      validateMissedClockout={validateMissedClockout}
      validateClockOut={validateClockOut}
      mealReminder={mealReminder}
      setMealReminder={setMealReminder}
      missedClockOutMeal={missedClockOutMeal}
      dataLoaded={dataLoaded}
      setDisableClockOut = {setDisableClockOut}
      // setExceptionDate={setExceptionDate}
    />
  );
};

PunchContainer.propTypes = {};

export default PunchContainer;
